import React, {Fragment} from 'react';

const Faq = () => {
    return (
        <Fragment>

        </Fragment>
    )
};

export default Faq;